import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { CheckFilledCircleIcon } from '@gemini/icons';
import { useTranslation } from '@/hooks/useTranslations';
import { useTransactionType } from '@/hooks/useTransactionType';
export function OfferCardFeature({ feature }) {
    const { t } = useTranslation();
    const { transactionType } = useTransactionType();
    const { description } = feature;
    const conditionedDescription = description !== 'offerCard.good.features.item1'
        ? description
        : `${description}.${transactionType}`;
    return (_jsxs(Box, { testId: "offer-card-feature", display: "flex", gap: "spacing.8", children: [_jsx(Box, { color: "color.border.status.success.default", height: "sizing.24", children: _jsx(CheckFilledCircleIcon, { testId: "offer-card-feature-icon", size: "sizing.24" }) }), _jsx(Box, { testId: "offer-card-feature-name", typography: "typography.body.16.regular", children: _jsx(Box, { children: t(conditionedDescription) }) })] }));
}
